import { render, staticRenderFns } from "./thirds_config_detail.vue?vue&type=template&id=a211f654&scoped=true"
import script from "./thirds_config_detail.vue?vue&type=script&lang=js"
export * from "./thirds_config_detail.vue?vue&type=script&lang=js"
import style0 from "./thirds_config_detail.vue?vue&type=style&index=0&id=a211f654&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a211f654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a211f654')) {
      api.createRecord('a211f654', component.options)
    } else {
      api.reload('a211f654', component.options)
    }
    module.hot.accept("./thirds_config_detail.vue?vue&type=template&id=a211f654&scoped=true", function () {
      api.rerender('a211f654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/config/thirds_config_detail.vue"
export default component.exports